module.exports = __webpack_public_path__ + "img/motomaid.e168f83d.jpg";